<template>
  <td class="border-t border-gray-100 p-2" data-el="Td"><slot /></td>
</template>
